import angular from 'angular';


angular.module('app.filters.properties', [])
    .filter('propsFilter', function() {
        "ngInject";
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {

                items.forEach(function(item) {
                    var itemMatches = false;
                    var keys = Object.keys(props);
                    var optionValue = '';
                    for (var i = 0; i < keys.length; i++) {
                         optionValue = item[keys[i]] ? optionValue + item[keys[i]].toString().toLowerCase().replace(/ /g, '') : '';
                    }
                    for (var j = 0; j < keys.length; j++) {
                        var text = props[keys[j]];
                        if (text) {
                          text = text.toLowerCase().replace(/ /g, '');
                        }
                        if (optionValue.indexOf(text) !== -1) {
                           itemMatches = true;
                           break;
                        }
                    }
                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
});



// WEBPACK FOOTER //
// ./src/app/filters/properties.js